export default __webpack_public_path__ + "80d18cf3e4ed1683f3025e108c48891d.png";